var snrAddToCart = function (opts) {
  opts = opts || {};

  var mainVariantId = opts.mainVariantId;
  var quantity = (typeof opts.quantity !== "undefined") ? opts.quantity : 1;
  var properties = opts.properties || {};
  var extras = opts.extras || [];

  if (!mainVariantId) {
    return Promise.reject(new Error("Missing variant id."));
  }

  var qtyParsed = parseInt(quantity, 10);
  var qty = (isNaN(qtyParsed) || qtyParsed < 1) ? 1 : qtyParsed;

  var uniqueId = properties._id || ("star-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8));

  var mainProperties = {};
  for (var k in properties) {
    if (Object.prototype.hasOwnProperty.call(properties, k)) mainProperties[k] = properties[k];
  }
  mainProperties._id = uniqueId;

  var items = [];

  for (var i = 0; i < extras.length; i++) {
    var extra = extras[i] || {};

    var extraId =
        (typeof extra.variantId !== "undefined" && extra.variantId) ||
        (typeof extra.id !== "undefined" && extra.id) ||
        (typeof extra.product_variant_id !== "undefined" && extra.product_variant_id);

    var rawQty = (typeof extra.quantity !== "undefined") ? extra.quantity : extra.amount;
    var parsedQty = parseInt(rawQty, 10);
    var extraQty = (isNaN(parsedQty) || parsedQty < 1) ? 0 : parsedQty;

    if (!extraId || extraQty < 1) continue;

    var extraProps = {};
    var srcProps = extra.properties || {};
    for (var p in srcProps) {
      if (Object.prototype.hasOwnProperty.call(srcProps, p)) extraProps[p] = srcProps[p];
    }
    extraProps._parent_id = uniqueId;

    items.push({
      id: extraId,
      quantity: extraQty,
      properties: extraProps
    });
  }

  items.push({
    id: mainVariantId,
    quantity: qty,
    properties: mainProperties
  });

  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({ items: items })
  }).then(function (response) {
    if (response.ok) return true;

    // try parse JSON error; if it fails, throw generic
    return response.json().catch(function () {
      return null;
    }).then(function (payload) {
      var message =
          (payload && payload.description) ||
          (payload && payload.message) ||
          (payload && payload.error) ||
          ("Add to cart failed (" + response.status + ").");

      throw new Error(message);
    });
  });
};

if (typeof window !== "undefined") {
  window.snrAddToCart = snrAddToCart;
}

var formattedCartItems = function () {
  function shallowCopy(obj) {
    var out = {};
    var k;
    for (k in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, k)) out[k] = obj[k];
    }
    return out;
  }

  function withChildren(item) {
    var out = shallowCopy(item);
    out.children = [];
    return out;
  }

  return fetch('/cart.js').then(function (resp) {
    if (!resp || !resp.ok) return [];
    return resp.json().then(function (cartData) {
      if (!cartData || !Array.isArray(cartData.items)) return [];

      var items = cartData.items;
      var parents = {};
      var orphans = [];
      var i;

      for (i = 0; i < items.length; i += 1) {
        var item = items[i];
        var id = item.properties && item.properties._id;
        if (id) {
          parents[id] = withChildren(item);
        }
      }

      for (i = 0; i < items.length; i += 1) {
        var itemWithChildren = items[i];
        var pid = itemWithChildren.properties && itemWithChildren.properties._parent_id;
        if (pid && parents[pid]) {
          parents[pid].children.push(itemWithChildren);
        } else if (!pid && !(itemWithChildren.properties && itemWithChildren.properties._id)) {
          orphans.push(withChildren(itemWithChildren));
        }
      }

      for (i = 0; i < items.length; i += 1) {
        var itemOrphan = items[i];
        var pidMissing = itemOrphan.properties && itemOrphan.properties._parent_id;
        if (pidMissing && !parents[pidMissing]) {
          orphans.push(withChildren(itemOrphan));
        }
      }

      var merged = [];
      var key;
      for (key in parents) {
        if (Object.prototype.hasOwnProperty.call(parents, key)) {
          merged.push(parents[key]);
        }
      }
      merged = merged.concat(orphans);

      var result = [];
      for (i = 0; i < merged.length; i += 1) {
        var entry = merged[i];
        var children = entry.children || [];
        var childrenTotal = 0;
        var j;
        for (j = 0; j < children.length; j += 1) {
          childrenTotal += (children[j].line_price || 0);
        }
        var total = (entry.line_price || 0) + childrenTotal;
        var out = shallowCopy(entry);
        out.sum_line_price = total;
        result.push(out);
      }

      return result;
    });
  }).catch(function () {
    return [];
  });
};

var removeFromCart = function (key) {
  if (!key) return Promise.resolve(false);

  return fetch('/cart.js').then(function (cartResp) {
    if (!cartResp.ok) throw new Error('Cart fetch failed');
    return cartResp.json();
  }).then(function (cartData) {
    var items = (cartData && cartData.items) ? cartData.items : [];
    var target = null;
    var i;
    for (i = 0; i < items.length; i += 1) {
      if (items[i].key === key) {
        target = items[i];
        break;
      }
    }

    if (!target) {
      return true;
    }

    var parentId = target.properties && target.properties._id;
    var keysToRemove = [];

    // Remove children linked to this parent
    if (parentId) {
      for (i = 0; i < items.length; i += 1) {
        var item = items[i];
        if (item.properties && item.properties._parent_id === parentId) {
          keysToRemove.push(item.key);
        }
      }
    }

    // Remove target item last
    keysToRemove.push(target.key);

    var updates = {};
    for (i = 0; i < keysToRemove.length; i += 1) {
      updates[keysToRemove[i]] = 0;
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).catch(function () {
      return null;
    }).then(function (resp) {
      if (!resp || !resp.ok) {
        return false;
      }

      return true;
    });
  }).catch(function (error) {
    console.error(error);
    return false;
  });
};

function submitCountryLocalization(country) {
  if (!country) return;

  var form = document.createElement("form");
  form.action = "/localization";
  form.method = "POST";
  form.hidden = true;

  var method = document.createElement("input");
  method.type = "hidden";
  method.name = "_method";
  method.value = "PUT";

  var countryInput = document.createElement("input");
  countryInput.type = "hidden";
  countryInput.name = "country_code";
  countryInput.value = country;

  form.appendChild(method);
  form.appendChild(countryInput);
  document.body.appendChild(form);

  form.submit();
}

function initHeaderScripts() {

  var headerCurrencyDropdownId = 'header-currency-dropdown';
  if (window.Dropdown) {
    window.Dropdown.render(headerCurrencyDropdownId, null, {
      direction: 'down',
      dataAttrName: 'country-code',
      callback: function (country) {
        submitCountryLocalization(country);
      }
    });
  }

  var menuWrapper = document.querySelector('.header-menu-wrapper');
  if (!menuWrapper) return;

  var menuButton = menuWrapper.querySelector('.header-menu');
  var menuItems = menuWrapper.querySelector('.menu-items');
  var submenuItems = Array.prototype.slice.call(
      menuWrapper.querySelectorAll('.menu-main > li.submenu')
  );
  if (!menuButton || !menuItems) return;

  var outsideClickBound = false;

  function hasOpenSubmenu() {
    return submenuItems.some(function (item) {
      return item.classList.contains('submenu-open');
    });
  }

  function handleDocumentClick(event) {
    var clickedInsideMenu = event.target.closest('.header-menu-wrapper');
    if (!clickedInsideMenu) {
      closeSubmenus();
    }

    if (menuItems.classList.contains('open') && !clickedInsideMenu) {
      closeMenu();
    }
  }

  function syncOutsideClickListener() {
    var shouldListen = menuItems.classList.contains('open') || hasOpenSubmenu();
    if (shouldListen && !outsideClickBound) {
      document.addEventListener('click', handleDocumentClick);
      outsideClickBound = true;
    } else if (!shouldListen && outsideClickBound) {
      document.removeEventListener('click', handleDocumentClick);
      outsideClickBound = false;
    }
  }

  function closeSubmenus(exceptItem) {
    if (typeof exceptItem === "undefined") exceptItem = null;
    submenuItems.forEach(function (item) {
      if (item === exceptItem) return;
      item.classList.remove('submenu-open');

      var trigger = item.querySelector(':scope > a');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
    syncOutsideClickListener();
  }

  function closeMenu() {
    menuItems.classList.remove('open');
    menuButton.setAttribute('aria-expanded', 'false');
    closeSubmenus();
    syncOutsideClickListener();
  }

  function toggleMenu() {
    var isOpen = menuItems.classList.contains('open');

    if (isOpen) {
      closeMenu();
    } else {
      menuItems.classList.add('open');
      menuButton.setAttribute('aria-expanded', 'true');
      syncOutsideClickListener();
    }
  }

  closeMenu();
  menuButton.addEventListener('click', function (event) {
    event.preventDefault();
    toggleMenu();
  });

  submenuItems.forEach(function (item) {
    var trigger = item.querySelector(':scope > a');
    if (!trigger) return;

    trigger.setAttribute('aria-expanded', 'false');

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = item.classList.contains('submenu-open');

      closeSubmenus(item);

      if (!isOpen) {
        item.classList.add('submenu-open');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        item.classList.remove('submenu-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
      syncOutsideClickListener();
    });
  });
}

function initFooterDropdowns() {
  if (!window.Dropdown) return;

  window.Dropdown.render("footer-region-dropdown", null);
  window.Dropdown.render("footer-currency-dropdown", null, {
    dataAttrName: 'country-code', callback: function(country) {
      submitCountryLocalization(country);
    }
  });
}

function initProductForm() {
  var form = document.querySelector('.js-product-form');
  if (!form) return;

  var cartUrl = form.getAttribute('data-cart-url') || '/cart';
  var totalEl = document.querySelector('.js-total-price');
  var variantSelect = form.querySelector('select[name="id"]');
  var quantityInput = form.querySelector('input[name="quantity"]');
  var starNameInput = form.querySelector('input[name="properties[Star Name]"]');
  var dateInput = form.querySelector('input[name="properties[Date]"]');
  var constellationInput = form.querySelector('input[name="properties[Constellation]"]');
  var messageInput = form.querySelector('textarea[name="properties[Personalized Message]"]');
  var extraInputs = document.querySelectorAll('.js-extra-quantity');
  var totalFrame = null;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD'
    });
  }

  function getVariantPrice() {
    var option = null;
    if (variantSelect && variantSelect.selectedOptions && variantSelect.selectedOptions.length) {
      option = variantSelect.selectedOptions[0];
    }

    var priceStr = '0';
    var hasOptionPrice = false;
    if (option) {
      var optionPrice = option.getAttribute('data-price');
      if (optionPrice !== null && optionPrice !== '') {
        priceStr = optionPrice;
        hasOptionPrice = true;
      }
    }
    if (!hasOptionPrice && totalEl) {
      var initialPrice = totalEl.getAttribute('data-initial-price');
      if (initialPrice !== null && initialPrice !== '') priceStr = initialPrice;
    }

    var price = parseInt(priceStr, 10);
    return isNaN(price) ? 0 : price;
  }

  function getQuantity() {
    var qtyRaw = quantityInput && quantityInput.value ? quantityInput.value : '1';
    var qty = parseInt(qtyRaw, 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function calculateTotal() {
    if (!totalEl) return;
    var totalCents = getVariantPrice() * getQuantity();

    var i;
    for (i = 0; i < extraInputs.length; i += 1) {
      var input = extraInputs[i];
      var price = parseInt(input.getAttribute('data-variant-price') || '0', 10);
      var qty = parseInt(input.value || '0', 10);
      if (isNaN(price) || isNaN(qty) || qty < 1) continue;
      totalCents += price * qty;
    }

    totalEl.textContent = formatMoney(totalCents);
  }

  function scheduleCalculateTotal() {
    if (totalFrame !== null) return;

    var schedule = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 16);
    };

    totalFrame = schedule(function () {
      totalFrame = null;
      calculateTotal();
    });
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      scheduleCalculateTotal();
    });
  }
  if (quantityInput) {
    quantityInput.addEventListener('input', scheduleCalculateTotal);
  }
  var extraIndex;
  for (extraIndex = 0; extraIndex < extraInputs.length; extraIndex += 1) {
    extraInputs[extraIndex].addEventListener('input', scheduleCalculateTotal);
  }

  calculateTotal();

  function handleSubmit(event) {
    event.preventDefault();

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    var variantId = variantSelect ? variantSelect.value : null;
    var starName = starNameInput ? starNameInput.value.trim() : '';
    var starDate = dateInput ? dateInput.value.trim() : '';
    var constellation = constellationInput ? constellationInput.value.trim() : '';
    var personalizedMessage = messageInput ? messageInput.value.trim() : '';

    var properties = {};
    if (starName) properties['Star Name'] = starName;
    if (starDate) properties.Date = starDate;
    if (constellation) properties.Constellation = constellation;
    if (personalizedMessage) properties['Personalized Message'] = personalizedMessage;

    var extras = [];
    var inputIndex;
    for (inputIndex = 0; inputIndex < extraInputs.length; inputIndex += 1) {
      var extraInput = extraInputs[inputIndex];
      extras.push({
        variantId: extraInput.getAttribute('data-variant-id'),
        quantity: extraInput.value
      });
    }

    var payload = {
      mainVariantId: variantId,
      quantity: getQuantity(),
      properties: properties,
      extras: extras
    };

    snrAddToCart(payload).then(function (success) {
      if (success) {
        window.location.href = cartUrl;
      } else {
        form.removeEventListener('submit', handleSubmit);
        form.submit();
      }
    }).catch(function () {
      form.removeEventListener('submit', handleSubmit);
      form.submit();
    }).then(function () {
      if (submitButton) submitButton.disabled = false;
    });
  }

  form.addEventListener('submit', handleSubmit);
}

function initSnrPage() {
  initHeaderScripts();
  initFooterDropdowns();
  initProductForm();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSnrPage, { once: true });
} else {
  initSnrPage();
}

// Cart helpers: remove parent item and attached extras together
document.addEventListener('click', function (event) {
  var link = event.target.closest('.js-remove-parent');
  if (!link) return;

  var targetKey = link.getAttribute('data-key');
  if (!targetKey) return;

  event.preventDefault();
  link.setAttribute('aria-busy', 'true');
  link.classList.add('is-loading');

  removeFromCart(targetKey)
    .then(function (ok) {
      if (ok) {
        window.location.reload();
      } else {
        window.location.href = link.href;
      }
    })
    .catch(function () {
      window.location.href = link.href;
    });
});
